import React from 'react';
import { Button, Icon, Typography } from '@saviynt/design-system';

import CsvIcon from '../../../../../components/illustrations/CSVIcon';

import './FilePrompt.css';

interface FilePromptProps {
  file: File;
  onRemove?: () => void;
  isCloseVisible: boolean;
  isProgressVisible: boolean;
  uploadProgress: number | null;
}

/**
 * FilePrompt component for displaying file information using FilePrompt CSS classes
 */
function FilePrompt({
  file,
  onRemove,
  isCloseVisible = true,
  isProgressVisible = false,
  uploadProgress = null,
}: FilePromptProps) {
  return (
    <div className='FilePrompt-FileDisplay'>
      <div className='FilePrompt-FileDisplay-List'>
        <div className='FilePrompt-FileDisplay-Item'>
          <div className='FilePrompt-FileDisplay-Info'>
            <div className='FilePrompt-FileDisplay-prefix' />
            <CsvIcon />
            <span className='FilePrompt-FileDisplay-FileName'>
              <Typography kind='body2'>{file.name}</Typography>
            </span>
            <span className='FilePrompt-FileDisplay-FileSize'>
              ({Math.round(file.size / 1024)} KB)
            </span>
            {isCloseVisible && onRemove && (
              <div className='FilePrompt-FileDisplay-RemoveButton'>
                <Button
                  leftIcon={<Icon kind='Close' size='xSmall' />}
                  onClick={onRemove}
                  size='small'
                  kind='saviGhost'
                />
              </div>
            )}
          </div>
          {isProgressVisible &&
            uploadProgress !== null &&
            uploadProgress < 100 && (
              <div className='FilePrompt-FileDisplay-Progress'>
                <div
                  className='FilePrompt-FileDisplay-ProgressBar'
                  style={{ width: `${uploadProgress}%` }}
                />
              </div>
            )}
        </div>
      </div>
    </div>
  );
}

FilePrompt.defaultProps = {
  onRemove: undefined,
};

export default FilePrompt;
